'use strict';
module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/add-to-unscopables.js
// module id = 235
// module chunks = 13